import {
  getPurchaseFlowBookingById,
  resetPurchase,
} from '@/features/purchase/purchaseActions';
import {
  purchaseFlowBookingIdSelector,
  purchaseFlowBookingSelector,
} from '@/features/purchase/purchaseSelectors';
import { useExpiryCountdown } from '@/hooks/useExpiryCountdown';
import { persistor } from '@/store';
import { useDispatch, useSelector } from '@/store/utils';
import { isAfter } from 'date-fns';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export type { CountdownTime } from '@/hooks/useExpiryCountdown';

export function useInProgressBookingController() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const bookingId = useSelector(purchaseFlowBookingIdSelector);
  const booking = useSelector(purchaseFlowBookingSelector);
  const [isValidating, setIsValidating] = useState(true);
  const countdown = useExpiryCountdown(booking?.confirmableUntil);

  useEffect(() => {
    if (bookingId && !booking?.code) {
      void dispatch(getPurchaseFlowBookingById(bookingId))
        .unwrap()
        .catch(() => {
          dispatch(resetPurchase());
          void persistor.purge();
        });
    } else if (booking?.confirmableUntil) {
      const isExpired = isAfter(new Date(), new Date(booking.confirmableUntil));

      if (isExpired) {
        dispatch(resetPurchase());
        persistor.purge().then(() => {
          setIsValidating(false);
        });
      } else {
        setIsValidating(false);
      }
    } else {
      setIsValidating(false);
    }
  }, [bookingId, booking, dispatch]);

  const handleCheckoutClick = useCallback(
    (onBeforeNavigate?: () => void) => {
      onBeforeNavigate?.();
      navigate('/purchase/checkout');
    },
    [navigate]
  );

  return {
    bookingId,
    booking,
    isValidating,
    countdown,
    handleCheckoutClick,
  };
}
